export const TERMINTYP_BESPRECHUNG = 1
export const TERMINTYP_PRIVAT = 5;
export const TERMINTYP_TELEFON_BESPRECHNUNG = 9
export const TERMINTYP_INTERNE_VORBEREITUNG = 10
export const TERMINTYP_TATTOO = 6
export const TERMINTYP_PIERCING = 8

export const CHANGE_RESTRICTED_TERMINTYPEN = [TERMINTYP_TATTOO, TERMINTYP_PIERCING, TERMINTYP_PRIVAT, TERMINTYP_BESPRECHUNG]

export const TERMINTYPEN_DEPOSIT = [TERMINTYP_BESPRECHUNG, TERMINTYP_TELEFON_BESPRECHNUNG]

export const termintypToSelection = (termintyp) => ({id: termintyp.TermintypID, text: termintyp.Termintyp })

export const CATEGORY_CUSTOMER_SERVICE = 1
export const CATEGORY_CUSTOMER_PREPARATION = 2
export const CATEGORY_CUSTOMER_INTERACTION = 3
export const CATEGORY_INTERNAL_BLOCK = 4
export const CATEGORIES_WITH_CUSTOMER_VISIBILITY = [CATEGORY_CUSTOMER_SERVICE, CATEGORY_CUSTOMER_INTERACTION]
export const CATEGORIES_WITH_CUSTOMER_RELATIONSHIP = [CATEGORY_CUSTOMER_SERVICE, CATEGORY_CUSTOMER_INTERACTION, CATEGORY_CUSTOMER_PREPARATION]
export const MULTIDAY_ALLOWED_CATEGORIES = [CATEGORY_INTERNAL_BLOCK]


export const CUSTOMER_POLICY_FORBIDDEN = 1
export const CUSTOMER_POLICY_RECOMMENDED = 2

export const isCustomerPolicyRecommended = (tt) => tt?.customer_policy === CUSTOMER_POLICY_RECOMMENDED
export const isCustomerPolicyForbidden = (tt) => tt?.customer_policy === CUSTOMER_POLICY_FORBIDDEN

export const isCustomerVisibleCategory = (tt) => CATEGORIES_WITH_CUSTOMER_VISIBILITY.includes(tt?.category)

/**
 * Derives customer_policy from category for save operations.
 * Categories with customer visibility get RECOMMENDED, others get FORBIDDEN.
 */
export const deriveCustomerPolicyFromCategory = (category) => {
    if (CATEGORIES_WITH_CUSTOMER_VISIBILITY.includes(category)) {
        return CUSTOMER_POLICY_RECOMMENDED;
    }
    return CUSTOMER_POLICY_FORBIDDEN;
}

/**
 * Checks if a given category value allows customer visibility (and thus online booking)
 */
export const isCategoryWithCustomerVisibility = (category) => {
    return CATEGORIES_WITH_CUSTOMER_VISIBILITY.includes(category);
}

/**
 * Category options with i18n keys for UI selection components
 */
export const CATEGORY_OPTIONS = [
    {
        value: CATEGORY_CUSTOMER_SERVICE,
        nameKey: "STUDIO_APPOINTMENT_TYPES_SETTINGS.CATEGORY_CUSTOMER_SERVICE_NAME",
        descKey: "STUDIO_APPOINTMENT_TYPES_SETTINGS.CATEGORY_CUSTOMER_SERVICE_DESC",
    },
    {
        value: CATEGORY_CUSTOMER_INTERACTION,
        nameKey: "STUDIO_APPOINTMENT_TYPES_SETTINGS.CATEGORY_CUSTOMER_INTERACTION_NAME",
        descKey: "STUDIO_APPOINTMENT_TYPES_SETTINGS.CATEGORY_CUSTOMER_INTERACTION_DESC",
    },
    {
        value: CATEGORY_CUSTOMER_PREPARATION,
        nameKey: "STUDIO_APPOINTMENT_TYPES_SETTINGS.CATEGORY_CUSTOMER_PREPARATION_NAME",
        descKey: "STUDIO_APPOINTMENT_TYPES_SETTINGS.CATEGORY_CUSTOMER_PREPARATION_DESC",
    },
    {
        value: CATEGORY_INTERNAL_BLOCK,
        nameKey: "STUDIO_APPOINTMENT_TYPES_SETTINGS.CATEGORY_INTERNAL_BLOCK_NAME",
        descKey: "STUDIO_APPOINTMENT_TYPES_SETTINGS.CATEGORY_INTERNAL_BLOCK_DESC",
    },
]
export const isCustomerServiceCategory = (tt) => tt?.category === CATEGORY_CUSTOMER_SERVICE
export const isBookableOnline = (tt) => Boolean(tt?.is_bookable_online)
export const isChangeRestrictedTermintyp = (termintypId) =>
    CHANGE_RESTRICTED_TERMINTYPEN.includes(termintypId)
export const isCustomerAttachedTermintyp = (category) => CATEGORIES_WITH_CUSTOMER_RELATIONSHIP.includes(category)

export const isTypForDeposit = (termintyp) => termintyp?.category === CATEGORY_CUSTOMER_INTERACTION
